export enum I18Enum {
    EN = 'en', // 英文
    ARABIC = 'ara', // 阿拉伯
    KR = 'kr', // 韩国
    JPN = 'jpn' // 日本
}